import {Resource} from '@raison/types';
import {RsnPane} from '@raison/ui-kit';
import React, {Fragment} from 'react';
import {Link, To} from 'react-router';
import {DashboardCategoryContext} from '~/features/dashboard-asset-pages';
import {DashboardCategoryTotal} from '../model/DashboardCategoryTotal';
import {DashboardCategoryShortLine} from './DashboardCategoryShortLine';

function renderContent(icon: string, title: string, details: Resource.Or<DashboardCategoryTotal>) {
    return (
        <Fragment>
            <RsnPane.IconFrame>
                <RsnPane.Icon src={icon} />
            </RsnPane.IconFrame>
            <RsnPane.TextBlock>
                <RsnPane.PrimaryText>{title}</RsnPane.PrimaryText>
                <RsnPane.SecondaryText stretch>
                    <DashboardCategoryShortLine totals={details} width={160} />
                </RsnPane.SecondaryText>
            </RsnPane.TextBlock>
            <RsnPane.Arrow />
        </Fragment>
    );
}
export function DashboardCategoryLink({icon, title, total: details, to}: DashboardCategoryLink.Props) {
    return (
        <RsnPane as={Link} to={to} className={'py-4'}>
            {renderContent(icon, title, details)}
        </RsnPane>
    );
}
DashboardCategoryLink.Stub = function DashboardCategoryLinkStub(props: {
    icon: string;
    title: string;
    details: DashboardCategoryTotal;
    onClick: () => void;
    kindPlural: string;
    kindSingular: string;
}) {
    return (
        <DashboardCategoryContext.Provider value={{...props, color: ''}}>
            <RsnPane as='button' onClick={props.onClick} className='py-4'>
                {renderContent(props.icon, props.title, props.details)}
            </RsnPane>
        </DashboardCategoryContext.Provider>
    );
};

export namespace DashboardCategoryLink {
    export type Props = {
        icon: string;
        title: string;
        total: Resource.Or<DashboardCategoryTotal>;
        to: To;
    };
}
